import React from "react";
import "./WorkspaceDescription.css";

function clean(value) {
  if (value === null || value === undefined) return "";

  const text = String(value).trim();

  return ["", "null", "undefined", "n/a", "-"].includes(text.toLowerCase())
    ? ""
    : text;
}

export default function WorkspaceDescription({ data }) {
  if (!data) return null;

  const city = clean(data.city);
  const state = clean(data.state);
  const size = clean(data.size);
  const floor = clean(data.floor);
  const address = clean(data.address);
  const landmark = clean(data.location);
  const description = clean(data.description);

  const place = [city, state].filter(Boolean).join(", ");

  const rawRent = clean(data.rent_price);
  const rent = Number(rawRent.replace(/,/g, ""));

  const formattedRent =
    rawRent && Number.isFinite(rent) && rent > 0
      ? `₹${rent.toLocaleString("en-IN")}`
      : "";

  const overview = [
    `This workspace rental listing${place ? ` in ${place}` : ""} provides property details for prospective tenants.`,
    formattedRent ? `The listed monthly rent is ${formattedRent}.` : "",
    size ? `The size is listed as ${size} (in feet).` : "",
    floor ? `The floor is listed as ${floor}.` : "",
  ]
    .filter(Boolean)
    .join(" ");

  const locationDetails = [
    address ? `The listed address is ${address}.` : "",
    landmark ? `The listed landmark is ${landmark}.` : "",
    place ? `The property is located in ${place}.` : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <section
      className="workspace-description"
      aria-label="Workspace rental overview"
    >
      <span className="workspace-description__label">RENTAL OVERVIEW</span>

      <h2>About this workspace{city ? ` in ${city}` : ""}</h2>

      <p>{overview}</p>

      {locationDetails && (
        <>
          <h3>Location details</h3>
          <p>{locationDetails}</p>
        </>
      )}

      {description && (
        <>
          <h3>Property description</h3>
          <p className="workspace-description__original">{description}</p>
        </>
      )}

      <h3>What to check during a visit</h3>

      <p>
        Visit the property to check its usable dimensions, ventilation,
        lighting, electrical connections, water supply, and access. Confirm
        staircase or lift access, loading arrangements, and parking where these
        are relevant to your work. If you plan to install embroidery machines or
        other equipment, confirm the permitted use, available electrical load,
        floor load capacity, and noise restrictions with the owner.
      </p>

      <h3>Confirm the rental terms</h3>

      <p>
        Ask the owner about the security deposit, maintenance charges,
        electricity and water billing, agreement duration, rent increases, and
        notice period. Confirm whether any brokerage, installation, or other
        additional charges apply before finalising the rental.
      </p>

      <p className="workspace-description__note">
        Property information is supplied in the listing. Confirm current
        availability, measurements, facilities, and final rental terms directly
        with the owner.
      </p>
    </section>
  );
}
